<template>
  <div class="question-frame">
    <div class="question-box">
      <div class="question" v-html="question"></div>
      <div class="next-question" v-html="nextQuestion"></div>
    </div>
    <div class="answer-box">
      <div class="answers">
        <div
          class="ans-btn"
          v-for="(ans, index) in answers"
          :key="index"
          :data-destination="ans.destination"
          :data-outsideptn="ans.outsidePtn"
          :data-galabel="ans.gaLabel"
          @click="onAnswerBtnClick"
        >{{ans.face}}</div>
      </div>
      <div class="next-answers">
        <div
          class="ans-btn"
          v-for="(ans, index) in nextAnswers"
          :key="index"
          :data-destination="ans.destination"
          :data-outsideptn="ans.outsidePtn"
        >{{ans.face}}</div>
      </div>
    </div>
    <div class="backToPrev" @click="onBackToPrevClick">前に戻る</div>
  </div>
</template>

<script>
export default {
  name: "LpLicoriceQuestion",
  data () {
    return {
      lock: true,
      isFirstIn: true,
      question: '',
      nextQuestion: '',
      answers: [],
      nextAnswers: [],
      history: [],
      logging: [],
      backCnt: 0,
      questionData: {
        q01: {
          qTitle: '設問_01',
          question: '恋愛で気がかりなことが<br>おありですか？',
          backbtn: false,
          buttons: [
            {
              face: 'はい',
              destination: 'q02A',
              gaLabel: 'lp_question1_yes'
            },
            {
              face: 'いいえ',
              destination: 'q02B',
              gaLabel: 'lp_question1_no'
            }
          ]
        },
        q02A: {
          qTitle: '設問_02A',
          question: '現在、好きな人は<br>いらっしゃいますか？',
          backbtn: true,
          buttons: [
            {
              face: 'はい',
              destination: 'q02A_a',
              gaLabel: 'lp_question2_yes'
            },
            {
              face: 'いいえ',
              destination: '__outside__',
              outsidePtn: 'ptnD',
              gaLabel: 'lp_question2_no'
            }
          ]
        },
        q02A_a: {
          qTitle: '設問_02A_a',
          question: 'その方とお付き合い<br>されていますか？',
          backbtn: true,
          buttons: [
            {
              face: 'はい',
              destination: '__outside__',
              outsidePtn: 'ptnA',
              gaLabel: 'lp_question3_yes'
            },
            {
              face: 'いいえ',
              destination: '__outside__',
              outsidePtn: 'ptnB',
              gaLabel: 'lp_question3_no'
            },
            {
              face: 'わからない',
              destination: '__outside__',
              outsidePtn: 'ptnC',
              gaLabel: 'lp_question3_neither'
            }
          ]
        },
        q02B: {
          qTitle: '設問_02B',
          question: 'では、人間関係への<br>気がかりはおありですか？',
          backbtn: true,
          buttons: [
            {
              face: 'はい',
              destination: '__outside__',
              outsidePtn: 'ptnE',
              gaLabel: 'lp_question4_yes'
            },
            {
              face: 'いいえ',
              destination: 'q02B_b',
              gaLabel: 'lp_question4_no'
            }
          ]
        },
        q02B_b: {
          qTitle: '設問_02B_b',
          question: 'なるほど。では、<br>自分のことは好きですか？',
          backbtn: true,
          buttons: [
            {
              face: '好き',
              destination: '__outside__',
              outsidePtn: 'ptnF',
              gaLabel: 'lp_question5_yes'
            },
            {
              face: '嫌い',
              destination: '__outside__',
              outsidePtn: 'ptnG',
              gaLabel: 'lp_question5_no'
            },
            {
              face: 'わからない',
              destination: '__outside__',
              outsidePtn: 'ptnH',
              gaLabel: 'lp_question5_neither'
            }
          ]
        },
      },
      outsidePatterns: {
        ptnA: {
          name: 'パターンA：彼氏あり',
          title: '想い合って、それから-Licorice-',
          url: '/movie/fast/12/detail/050015',
          freeurl: '/movie/fast/13/detail/050023',
          targetblank: false
        },
        ptnB: {
          name: 'パターンB：恋人ではない好きな人がいる',
          title: '片想いのその先に-Licorice-',
          url: '/movie/fast/12/detail/050016',
          freeurl: '/movie/fast/13/detail/050024',
          targetblank: false
        },
        ptnC: {
          name: 'パターンC：関係がわからない好きな人がいる',
          title: '近くて遠い私と彼-Licorice-',
          url: '/movie/fast/12/detail/050017',
          freeurl: '/movie/fast/13/detail/050025',
          targetblank: false
        },
        ptnD: {
          name: 'パターンD：好きな人はいない',
          title: 'まだ始まらない恋のハナシ-Licorice-',
          url: '/movie/fast/12/detail/050018',
          freeurl: '/movie/fast/13/detail/050026',
          targetblank: false
        },
        ptnE: {
          name: 'パターンE：人間関係の悩み',
          title: '誰かはきっと側にいる-Licorice-',
          url: '/movie/fast/12/detail/050019',
          freeurl: '/movie/fast/13/detail/050027',
          targetblank: false
        },
        ptnF: {
          name: 'パターンF：自分のことが好き',
          title: '頑張るあなたへのストーリー-Licorice-',
          url: '/movie/fast/12/detail/050020',
          freeurl: '/movie/fast/13/detail/050028',
          targetblank: false
        },
        ptnG: {
          name: 'パターンG：自分のことが嫌い',
          title: '自分を好きになれない君へ-Licorice-',
          url: '/movie/fast/12/detail/050021',
          freeurl: '/movie/fast/13/detail/050029',
          targetblank: false
        },
        ptnH: {
          name: 'パターンH：自分を好きか嫌いかわからない',
          title: '“ワタシ”を探す物語-Licorice-',
          url: '/movie/fast/12/detail/050022',
          freeurl: '/movie/fast/13/detail/050030',
          targetblank: false
        },
      },
      elm: {
        q: null,
        qn: null,
        a: null,
        an: null,
        btp: null
      }
    }
  },
  props: {
    isThresholdReached: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  mounted () {
    this.elm.q = this.$el.querySelector('.question-box .question')
    this.elm.qn = this.$el.querySelector('.question-box .next-question')
    this.elm.a = this.$el.querySelector('.answer-box .answers')
    this.elm.an = this.$el.querySelector('.answer-box .next-answers')
    this.elm.btp = this.$el.querySelector('.backToPrev')

    const firstKey = 'q01'
    this.history.unshift(firstKey)
    this.nextQuestion = this.questionData[firstKey].question
    this.nextAnswers.splice(0)
    for(let item of this.questionData[firstKey].buttons) {
      this.nextAnswers.push({
        face: item.face,
        destination: item.destination,
        outsidePtn: item.outsidePtn != null ? item.outsidePtn : null,
        gaLabel: item.gaLabel
      })
    }
    const _this = this
    setTimeout(()=>{
      _this.transQuestion('q01')
    },1000)
  },
  methods: {
    onAnswerBtnClick (e) {
      if( !this.lock) {
        this.lock = true
        const tgtkey = e.target.dataset.destination

        window.gtag('event', 'click', {'event_category': 'Licorice_LP', 'event_label': e.target.dataset.galabel, 'value': 1 })

        if(tgtkey === '__outside__') {
          const tgtPtn = this.outsidePatterns[e.target.dataset.outsideptn]
          if(tgtPtn != null) {
            let logs = ''
            for( let item of this.logging ) {
              logs += `${item} > `
            }
            logs += `> > ${e.target.dataset.outsideptn}`
            const tgturl = this.isThresholdReached ? tgtPtn.url : tgtPtn.freeurl
            if(!tgtPtn.targetblank){
              location.href = tgturl
            } else {
              window.open(tgturl, '_blank')
            }
          }
        } else {
          if(tgtkey in this.questionData) {
            this.nextQuestion = this.questionData[tgtkey].question
            this.nextAnswers.splice(0)
            for(let item of this.questionData[tgtkey].buttons) {
              this.nextAnswers.push({
                face: item.face,
                destination: item.destination,
                outsidePtn: item.outsidePtn != null ? item.outsidePtn : null,
                gaLabel: item.gaLabel
              })
            }
            this.history.unshift(tgtkey)
            this.transQuestion(tgtkey)
          }
        }
      }
    },
    onBackToPrevClick (e) {
      if( !this.lock ) {
        this.lock = true
        this.history.shift()
        if(this.history[0] != null){
          const tgtkey = this.history[0]
          this.nextQuestion = this.questionData[tgtkey].question
          this.nextAnswers.splice(0)
          for(let item of this.questionData[tgtkey].buttons) {
            this.nextAnswers.push({
              face: item.face,
              destination: item.destination,
              outsidePtn: item.outsidePtn != null ? item.outsidePtn : null,
              gaLabel: item.gaLabel
            })
          }
          this.backCnt++
          window.gtag('event', 'click', {'event_category': 'Licorice_LP', 'event_label': 'lp_question_back', 'value': this.backCnt })
          this.transQuestion(this.history[0])
        }
      }
    },
    transQuestion (target) {
      this.logging.push(target)
      if( !this.isFirstIn ) {
        this.elm.an.addEventListener('animationend', this.completeTransition)
        this.elm.q.classList.add('q-out')
        this.elm.a.classList.add('a-out')
        this.elm.qn.classList.add('q-in')
        this.elm.an.classList.add('a-in')
        if(this.elm.btp.classList.contains('btp-in') || this.elm.btp.classList.contains('show')) {
          this.elm.btp.classList.add('btp-out')
        }
      } else {
        this.elm.qn.classList.add('q-first-in')
        this.elm.an.addEventListener('animationend', this.completeTransition)
        this.elm.an.classList.add('a-first-in')
        this.isFirstIn = false
      }
    },
    completeTransition () {
      this.elm.an.removeEventListener('animationend', this.completeTransition)
      this.elm.an.classList.remove('a-first-in')
      this.elm.an.classList.remove('a-in')
      this.elm.a.classList.remove('a-out')
      this.answers.splice(0)
      for(let item of this.nextAnswers) {
        this.answers.push({
          face: item.face,
          destination: item.destination,
          outsidePtn: item.outsidePtn != null ? item.outsidePtn : null,
          gaLabel: item.gaLabel
        })
      }

      this.elm.qn.classList.remove('q-first-in')
      this.elm.qn.classList.remove('q-in')
      this.elm.q.style.visibility = 'visible'
      this.elm.q.classList.remove('q-out')
      this.question = this.nextQuestion

      if(this.questionData[this.history[0]].backbtn){
        this.elm.btp.classList.remove('btp-out')
        this.elm.btp.classList.add('btp-in')
      }
      this.lock = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables/index";
.question-frame {
  width: 100%;
  position: relative;
  height: 126vw;
  border: 3px solid $brown-5;
  border-radius: 20px;
  box-sizing: border-box;
  background: $white;
  color: $brown-5;
  padding: 24px 18px 28px;
  @include mq('w320'){
    padding: 32px 18px 28px;
    height: 112vw;
  }
  @include mq () {
    width: 320px;
    height: 420px;
    margin: 0 auto;
  }
  .question-box {
    width: 100%;
    height: 72px;
    text-align: center;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    position: relative;
    @include mq('w320'){
      height: 78px;
    }
    @include mq () {
      height: 72px;
    }
    .question {
      position: absolute;
      border-bottom: 2px solid $brown-5;
      width: 100%;
      height: 100%;
      top: 0;
      opacity: 1;
      visibility: hidden;
    }
    .next-question {
      position: absolute;
      border-bottom: 2px solid $brown-5;
      width: 100%;
      height: 100%;
      top: 0;
      opacity: 0;
    }
  }
  .answer-box {
    width: 100%;
    padding: 24px 8px 18px;
    position: relative;
    .ans-btn {
      width: 100%;
      height: 55px;
      border-radius: 5px;
      background: $brown-6;
      line-height: 1;
      font-weight: 600;
      font-size: 18px;
      color: $white;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 16px;
      cursor: pointer;
      @include mq ('w320') {
        margin-bottom: 20px;
      }
    }
    .answers {
      width: calc(100% - ( 8px + 8px ));
      position: absolute;
      top: 24px;
      left: 8px;
      z-index: 10;
      opacity: 1;
    }
    .next-answers {
      width: calc(100% - ( 8px + 8px ));
      position: absolute;
      top: 24px;
      left: 8px;
      z-index: 20;
      opacity: 0;
      pointer-events: none;
    }
  }
  .backToPrev {
    position: absolute;
    left: 28px;
    bottom: 20px;
    opacity: 0;
    user-select: none;
    cursor: pointer;
    z-index: 100;
    &.show {
      opacity: 1;
    }
    &::before {
      content: '<';
      display: inline-block;
      margin-right: 4px;
    }
  }
}

.q-first-in {
  animation: kf_fadeIn 300ms ease-out 0s 1 normal both;
}
.q-in {
  animation: kf_fadeIn 300ms ease-out 700ms 1 normal both;
}
.q-out {
  animation: kf_fadeOut 300ms ease-out 0s 1 normal both;
}
.a-in {
  animation: kf_fadeIn 300ms ease-out 700ms 1 normal both;
}
.a-first-in {
  animation: kf_fadeIn 300ms ease-out 0s 1 normal both;
}
.a-out {
  animation: kf_fadeOut 300ms ease-out 0s 1 normal both;
}
.btp-in {
  animation: kf_fadeIn 300ms ease-out 0s 1 normal both;
}
.btp-out {
  animation: kf_fadeOut 300ms ease-out 0s 1 normal both;
}
@keyframes kf_fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes kf_fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/lp/licorice/LpLicoriceQuestion.vue